import { useEffect, useState } from "react";
import { Logo, FlameMark } from "@/components/Logo";
import { useLang } from "@/i18n/LanguageContext";

const LINKS = [
  { key: "nav.parties", href: "#parties", id: "parties" },
  { key: "nav.clubs", href: "#clubs", id: "speaking-clubs" },
  { key: "nav.classes", href: "#classes", id: "classes" },
  { key: "nav.about", href: "#about", id: "about" },
];

const LANGS = [
  { id: "en", label: "EN" },
  { id: "es", label: "ES" },
  { id: "ru", label: "RU" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const { lang, setLang, t } = useLang();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-nav"
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-500 ${
        scrolled ? "border-b border-white/10 bg-black/60 backdrop-blur-xl" : "border-b border-transparent"
      }`}
    >
      <div className="relative mx-auto flex max-w-7xl items-center justify-between gap-3 px-5 py-4 md:px-8">
        <Logo />
        <p
          data-testid="nav-tagline"
          className="absolute left-1/2 top-1/2 hidden -translate-x-1/2 -translate-y-1/2 items-center gap-2 whitespace-nowrap text-[10px] font-bold uppercase tracking-[0.2em] text-white/60 sm:flex lg:text-[11px] lg:tracking-[0.3em]"
        >
          <FlameMark className="h-3.5 w-3.5 animate-flicker text-flame" />
          {t("hero.eyebrow")}
        </p>
        <div className="flex items-center gap-3">
          <div data-testid="lang-switcher" className="flex items-center gap-0.5 rounded-full border border-white/15 bg-black/40 p-1 backdrop-blur">
            {LANGS.map((l) => (
              <button
                key={l.id}
                data-testid={`lang-switch-${l.id}`}
                onClick={() => setLang(l.id)}
                className={`rounded-full px-2.5 py-1 text-[11px] font-bold tracking-wide transition-colors duration-300 ${
                  lang === l.id ? "bg-flame text-white" : "text-white/50 hover:text-white"
                }`}
              >
                {l.label}
              </button>
            ))}
          </div>
          <a
            data-testid="nav-book-class-btn"
            href="#classes"
            className="flame-glow hidden rounded-full bg-flame px-5 py-2 text-sm font-bold text-white transition-colors duration-300 hover:bg-ember lg:block"
          >
            {t("nav.book")}
          </a>
        </div>
      </div>
      <nav className="hidden justify-center gap-8 pb-3 lg:flex">
        {LINKS.map((l) => (
          <a
            key={l.href}
            data-testid={`nav-link-${l.id}`}
            href={l.href}
            className="text-xs font-semibold uppercase tracking-[0.18em] text-white/55 transition-colors duration-300 hover:text-white"
          >
            {t(l.key)}
          </a>
        ))}
      </nav>
    </header>
  );
}
